import { useMemo } from 'react';

import { api, ReportFindingsByReportResponse } from '@/api';

import { ML_SERVER } from '../constant';
import { useFctReport } from './use-fct-report.hook';

export const useFctReportFindingsByReport = () => {
  const { report } = useFctReport();

  const { data, ...query } = api.fct.reportFinding.query.useGetReportFindingsByReport(
    {
      payload: {
        params: {
          size: 50,
          user_id: ML_SERVER,
        },
        uuid: report?.uuid,
      },
    },
    {
      enabled: false,
    },
  );

  const reportFindings = useMemo(
    () =>
      (data as unknown as { pages: ReportFindingsByReportResponse[] })?.pages.flatMap(
        (page) => page.items,
      ) ?? [],
    [data],
  );

  const value = useMemo(() => ({ ...query, reportFindings }), [query, reportFindings]);

  return value;
};
